import { render } from "./PostTags.vue?vue&type=template&id=cd01e26c&scoped=true"
import script from "./PostTags.vue?vue&type=script&lang=js"
export * from "./PostTags.vue?vue&type=script&lang=js"

import "./PostTags.vue?vue&type=style&index=0&id=cd01e26c&scoped=true&lang=css"

import exportComponent from "D:\\lawstudio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd01e26c"]])

export default __exports__